<template>
    <Pulse v-if="loadingBranding"/>
    <b-overlay v-else :show="loadingDeleteRequest">
        <b-row>
            <b-col md="6" class="mt-4">
                <b-card header="Email Management">
                    <p v-if="!usesOauth">If you wish to change the email address associated with your CPDme account, click the button below to make this change.</p>
                    <p v-else>Please contact your organisation for email change support.</p>
                    <b-button class="ovr-button" :disabled="usesOauth" @click="changeEmail">Change Email</b-button> 
                    <b-button class="ovr-button mt-2" :to="{name: 'email-history'}" style="width: fit-content">View Email Change History</b-button>
                </b-card>
            </b-col>
            <b-col md="6" class="mt-4">
                <b-card header="Password Management">
                    <p>If you wish to change the password associated with your CPDme account, click the button below to make this change.</p>
                    <b-button class="ovr-button" @click="changePassword">Change Password</b-button> 
                </b-card>
            </b-col>
            <b-col md="6" class="mt-4">
                <AccountDeletion />
            </b-col>
            <b-col md="6" class="mt-4">
                <b-card header="Payment Management">
                    <p>From the payment management page you can:</p>
                    <ul>
                        <li>Change your payment frequency</li>
                        <li>Cancel your membership</li>
                        <li>Start a new membership</li>
                        <li>Change your payment details</li>
                    </ul>
                    <b-button class="ovr-button" :to="{name: 'payment-management'}">Manage Payment Details</b-button>
                </b-card>
            </b-col>
            <ChangeUserEmailModal ref="changeEmailModal" />
            <ChangePasswordModal ref="changePasswordModal" />
        </b-row>
</b-overlay>

</template>

<script>

import ChangeUserEmailModal from "../../components/tools/ChangeUserEmailModal";
import ChangePasswordModal from "../../components/tools/ChangePasswordModal";
import Pulse from "@/components/loaders/Pulse";
import AccountDeletion from "@/components/AccountDeletion.vue";

export default {
    name: "AccountManagement",
    components: {ChangeUserEmailModal, ChangePasswordModal, Pulse, AccountDeletion},
    data() {
        return {
            loadingBranding: true,
            usesOauth: false,
            loadingDeleteRequest: false,
            isSuccessfulDeleteRequest: false,
        }
    },
    methods: {
        changeEmail() {
			    this.$refs.changeEmailModal.show();
            },
        changePassword() {
                this.$refs.changePasswordModal.show();
            },
        loadBranding() {
            this.$api.v2.get("branding").then((resp) => {
                this.usesOauth = resp.body.usesOauth;
            })
            this.loadingBranding = false;
        },
    },
    created() {
        this.loadBranding();
    }
}

</script>

<style>

</style>